<template>
  <div class="question">
    <div class="content">
      <div v-for="content in contents">
        <img :src="content.image" alt="">
        <p v-html="content.text">
        </p>
        <input
          type="text"
          name="input"
          :placeholder="input.placeholder"
          v-on:keyup.13="onSubmit"
          v-model="inputVal"
          v-if="input.isActive"
        />
        <input
          type="text"
          name="input"
          :placeholder="secondInput.placeholder"
          v-on:keyup.13="onSubmit"
          v-model="secondInputVal"
          v-if="secondInput.isActive"
        />
      </div>
    </div>

    <div class="button-container">
      <div class="button-caption" v-for="option in options">
        <router-link v-if="option.type != 'done' && option.isOption && !input.isActive && !option.isHttpRequest" :class="{ 'yes': option.type == 'yes', 'no': option.type == 'no', 'continue': option.type == 'continue', }" :to="{ name: 'Option', params: { id: option.id } }">
          <span v-if="option.type == 'continue'">DEVAM ET</span>
          <span v-if="option.type == 'yes'">EVET</span>
          <span v-if="option.type == 'no'">HAYIR</span>
        </router-link>

        <router-link v-if="option.type != 'done' && !option.isOption && !input.isActive && !option.isHttpRequest" :class="{ 'yes': option.type == 'yes', 'no': option.type == 'no', 'continue': option.type == 'continue', }" :to="{ name: 'Question', params: { id: option.id } }">
          <span v-if="option.type == 'continue'">DEVAM ET</span>
          <span v-if="option.type == 'yes'">EVET</span>
          <span v-if="option.type == 'no'">HAYIR</span>
        </router-link>

        <a
          v-if="input.isActive"
          v-on:click="onSubmit"
          :class="{
            'yes': option.type == 'yes',
            'no': option.type == 'no',
            'continue': option.type == 'continue',
          }"
        >
          <span v-if="option.type == 'continue'">DEVAM ET</span>
          <span v-if="option.type == 'yes'">EVET</span>
          <span v-if="option.type == 'no'">HAYIR</span>
        </a>

        <a
          v-if="option.isHttpRequest"
          v-on:click="option.onClick"
          :class="{
            'yes': option.type == 'yes',
            'no': option.type == 'no',
            'continue': option.type == 'continue',
          }"
        >
          <span v-if="option.type == 'continue'">DEVAM ET</span>
          <span v-if="option.type == 'yes'">EVET</span>
          <span v-if="option.type == 'no'">HAYIR</span>
        </a>

        <router-link v-if="option.type === 'done'" class="continue" :to="{ name: 'Success' }">
          <span>BİTİR</span>
        </router-link>
      </div>

    </div>
  </div>
</template>

<script>
export default {
  name: 'Question',
  data() {
    return {
      contents: [],
      options: [],
      inputVal: '',
      secondInputVal: '',
      input: {
        isActive: false,
        placeholder: null,
        value: null,
      },
      secondInput: {
        isActive: false,
        placeholder: null,
        value: null,
      },
      onSubmit: null,
    };
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .question {
    height: 435px;

    .content {
      max-height: 285px;
      overflow-y: scroll;
    }


    input {
      border: 1px solid #8a8a8a;
      padding: 5px 10px;
    }
  }

  .button-container {
    height: 120px;
    border-top: 1px solid rgba(214, 205, 205, 0.45);
    position: absolute;
    bottom: 30px;
    width: 100%;
  }

  .not-these {
    text-decoration: none;
    display: block;
    clear: both;
    margin: 10px auto;
    margin-bottom: 20px;
    width: 85%;
    box-sizing: border-box;
    padding: 15px 20px;
    text-align: left;
    font-size: 14px;
    background: #3586ad;
    color: #fff;
    border-radius: 4px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);

    i {
      float: right;
    }
  }

  .button-caption {
    float: left;
    width: auto;
    min-width: 50%;
    padding: 0 5px;
    box-sizing: border-box;

    a {
      text-decoration: none;
      border-radius: 4px;
      color: #FFFFFF;
      font-size: 14px;
      display: block;
      width: 75%;
      margin: 10px 0;
      padding: 10px;
      cursor: pointer;

      &.no {
        background: #E45D5D;
        float: left;
      }

      &.yes {
        background: #33BFA0;
        float: right;
      }

      &.continue {
        width: 260px;
        margin-left: 20px;
        background-color: #2B7EED;
      }
    }
  }

  p {
    color: #858484;
    font-size: 15px;
    padding: 10px;
    margin: 0;

    img {
      max-width: 90%;
      box-shadow: 0 10px 20px 0 rgba(0,0,0,0.20);
      border-radius: 4px;
    }
  }
</style>



// WEBPACK FOOTER //
// Question.vue?4c8f162c